import { render, staticRenderFns } from "./SubjectUpdateDialog.vue?vue&type=template&id=7abde8de&scoped=true"
import script from "./SubjectUpdateDialog.vue?vue&type=script&lang=js"
export * from "./SubjectUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./SubjectUpdateDialog.vue?vue&type=style&index=0&id=7abde8de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abde8de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7abde8de')) {
      api.createRecord('7abde8de', component.options)
    } else {
      api.reload('7abde8de', component.options)
    }
    module.hot.accept("./SubjectUpdateDialog.vue?vue&type=template&id=7abde8de&scoped=true", function () {
      api.rerender('7abde8de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/SubjectUpdateDialog.vue"
export default component.exports